// dashboardSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface clickedVideoType{
  videoCurrentTime: number;
  videoId: string;
}
interface DashboardState {
    selectedLibraryId: string | null;
    selectedSubjectId: string | null;
    selectedSubjectName: string | null;
    meetComponent: string;
    currentSessionId: string;
    currentWorkshopId: string;
    currentPtaMeetId: string;
    currentPtaMeetMCode: string;
    currentSessionTopic: string;
    clickedVideoData: clickedVideoType;
    changeMenu: boolean;
    categoryListLoading: boolean;
    currentSessionDetail: {
      startDate?: any,
      endDate?: any
      mediaPipelineArn? : any,
      mediaPipelineId? : any,
    },
    currentSessionRecordingDetail:{
      recordingStartedTime: string | null,
      recordingStarted: boolean
    },
    currentUserId: string;
    isStartingMeeting: boolean;
}

//initialState storing the selectedLibraryId and selectedSubjectId from the localStorage
const initialState: DashboardState = {
    selectedLibraryId: localStorage.getItem('selectedLId') || '',
    selectedSubjectId: localStorage.getItem('selectedSId') || '',
    selectedSubjectName: '',
    meetComponent: '',
    currentSessionId: '',
    currentWorkshopId: '',
    currentPtaMeetId: '',
    currentPtaMeetMCode: '',
    currentSessionTopic: '',
    currentSessionDetail: {
      startDate: null,
      endDate: null,
      mediaPipelineArn : null,
      mediaPipelineId : null
    },
    currentSessionRecordingDetail:{
      recordingStartedTime: null,
      recordingStarted: false
    },
    clickedVideoData: {
      videoCurrentTime: 0,
      videoId: ''
    },
    changeMenu: false,
    categoryListLoading: false,
    currentUserId: '',
    isStartingMeeting: false
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
       setSelectedLibraryId(state, action: PayloadAction<{ selectedLibraryId: string }>) {
            const encryptedId = action.payload.selectedLibraryId;
            localStorage.setItem('selectedLId', encryptedId);
            state.selectedLibraryId = action.payload.selectedLibraryId;
       },
       setSelectedSubjectId(state, action: PayloadAction<{ selectedSubjectId: string }>) {
        const encryptedId = action.payload.selectedSubjectId;
        localStorage.setItem('selectedSId', encryptedId);
        state.selectedSubjectId = action.payload.selectedSubjectId; // Fix typo here
       },
       setSelectedSubjectName(state, action: PayloadAction<{ selectedSubjectName: string }>) {
        state.selectedSubjectName = action.payload.selectedSubjectName; // Fix typo here
       },
       setMeetComponentName(state, action: PayloadAction<{ meetComponent: string }>){
        state.meetComponent = action.payload.meetComponent;
       },
       setCurrentSessionId(state, action: PayloadAction<{ currentSessionId: string }>){
         state.currentSessionId = action.payload.currentSessionId;
       },
       setCurrentWorkshopId(state, action: PayloadAction<{ currentWorkshopId: string }>){
        state.currentWorkshopId = action.payload.currentWorkshopId;
       },
       setCurrentPtaMeetId(state, action: PayloadAction<{ currentPtaMeetId: string }>){
        state.currentPtaMeetId = action.payload.currentPtaMeetId;
       },
       setCurrentPtaMeetMCode(state, action: PayloadAction<{ currentPtaMeetMCode: string }>){
        state.currentPtaMeetMCode = action.payload.currentPtaMeetMCode;
       },
       setCurrentSessionTopic(state, action: PayloadAction<{ currentSessionTopic: string }>){
        state.currentSessionTopic = action.payload.currentSessionTopic;
       },
       setCurrentSessionDetail(state, action: PayloadAction<{ startDate?: any, endDate?: any, mediaPipelineArn? : any, mediaPipelineId? : any  }>){
        state.currentSessionDetail = { ...state.currentSessionDetail, ...action.payload };
       },
       setCurrentSessionRecordingDetail(state, action: PayloadAction<{ recordingStartedTime: string|null, recordingStarted: boolean }>){
        state.currentSessionRecordingDetail = action.payload;
       },
       setCurrentVideoData(state, action: PayloadAction<{ videoCurrentTime: number, videoId: string }>){
        state.clickedVideoData.videoCurrentTime = action.payload.videoCurrentTime;
        state.clickedVideoData.videoId = action.payload.videoId;
       },
       setChangeMenu(state, action: PayloadAction<{ changeMenu: boolean }>){
        state.changeMenu = action.payload.changeMenu;
       },
       setCategoryListLoading(state, action: PayloadAction<{ categoryListLoading: boolean }>){
        state.categoryListLoading = action.payload.categoryListLoading;
       },
       setCurrentUserId(state, action: PayloadAction<{ currentUserId: string }>){
        state.currentUserId = action.payload.currentUserId;
       },
       setIsStartingMeeting(state, action: PayloadAction<{ isStartingMeeting: boolean }>){
        state.isStartingMeeting = action.payload.isStartingMeeting;
       }
  },
});

export const { setCurrentSessionDetail,setCurrentSessionRecordingDetail, setSelectedSubjectName, setSelectedLibraryId, setCurrentVideoData, setSelectedSubjectId, setMeetComponentName, setCurrentSessionId, setCurrentWorkshopId, setCurrentPtaMeetId, setCurrentPtaMeetMCode, setChangeMenu, setCategoryListLoading, setCurrentSessionTopic, setCurrentUserId, setIsStartingMeeting } = dashboardSlice.actions;
export default dashboardSlice.reducer;